<template>
  <Row>
    <i-form-item label="Conflict">
      <i-input v-model="value.conflict"></i-input>
    </i-form-item>

    <i-form-item label="Violence – Political">
      <i-input v-model="value.violence_political"></i-input>
    </i-form-item>

    <i-form-item label="Violence – Criminal">
      <i-input v-model="value.violence_criminal"></i-input>
    </i-form-item>

    <i-form-item label="Violence – Communal">
      <i-input v-model="value.violence_communal"></i-input>
    </i-form-item>

    <i-form-item label="Other">
      <i-input v-model="value.other"></i-input>
    </i-form-item>
  </Row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          other: null,
          conflict: null,
          violence_communal: null,
          violence_criminal: null,
          violence_political: null,
        };
      },
    },
  },
  updated() {
    this.$emit("input", this.value);
  },
};
</script>
